module.exports = __webpack_public_path__ + "static/media/zalo.20b018de.png";